<template>
   <div class="">
       <input type="file" ref="inputFile">
   </div>
</template>

<script>
    export default {
        props: {
            label: {
                type: String,
                default: ''
            },
            maxSize: {
                type: [Number, String],
                default: 550000
            },
            mimeType: {
                type: String,
                default: 'image/jpeg'
            },
            accept: {
                type: String,
                default: '*'
            },
            name: {
                type: String,
                default: 'file'
            },
            multiple: {
                type: [String, Number, Boolean],
                default: false
            },

            disableFileToSend: {
                type: [String, Number, Boolean],
                default: false
            },

            value: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                file: this.value,
                blob: null
            };
        },
        watch: {
            value: {
                handler( value ) {
                    this.file = value;
                },
                deep: true
            },
            file: {
                handler( files ) {
                    this.$emit('input', files );

                    const file = files.length ? files[0] : files;
                    let reader = new FileReader();
                    reader.onloadend = () => {
                        this.blob = this.createBlob( file );
                    };
                    reader.readAsDataURL(file);
                }
            }
        },
        mounted() {

        },
        methods: {
            createBlob( file, blobName, mimeType ) {
                let blob = new Blob([file], {type: mimeType || file.type});
                blob.name = blobName || file.name;

                return blob;
            },

            dataURLToBlob( dataURL ) {
                let BASE64_MARKER = ';base64,';

                if( dataURL.indexOf(BASE64_MARKER) === -1 ) {
                    let parts = dataURL.split(',');
                    let contentType = parts[0].split(':')[1];
                    let raw = parts[1];

                    return new Blob([raw], {type: contentType});
                }

                let parts       = dataURL.split(BASE64_MARKER);
                let contentType = parts[0].split(':')[1];
                let raw         = window.atob(parts[1]);
                let rawLength   = raw.length;

                let uInt8Array  = new Uint8Array(rawLength);

                for( let i = 0; i < rawLength; ++i ) {
                    uInt8Array[i] = raw.charCodeAt(i);
                }

                return new Blob([uInt8Array], {type: contentType});
            },

            validateFile( input ) {
                if( !input || !input.files || !input.files.length ) {
                    alert('File non valido.');
                    return false;
                }

                let file = input.files[0];
                if( !file.size || file.size > this.maxSize ) {
                    alert('ATTENZIONE! Il peso massimo dell\'immagine non può superare i 500 kb.');
                    return false;
                }

                let accept = input.attributes.accept;
                if( !accept ) {
                    alert('File non valido.');
                    return false;
                }

                let ext = file.type.split('/').pop();
                if( !ext ) {
                    alert('Extensione file non valida.');
                    return false;
                }

                if( accept.value.indexOf( ext ) < 0 ) {
                    alert('Extensione file non valida.');
                    return false;
                }

                return true;
            },

            getFilesToSend() {
                if( !!+this.disableFileToSend || !this.blob ) {
                    return [];
                }

                return [ this.blob ];
            }
        }
    }
</script>
